import { render, staticRenderFns } from "./NumberValue_3.vue?vue&type=template&id=2c4378f2&scoped=true&"
import script from "./NumberValue_3.vue?vue&type=script&lang=js&"
export * from "./NumberValue_3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4378f2",
  null
  
)

export default component.exports